import { Routes } from '@angular/router';

import { AuthGuard, LaunchDarklyUserGuard, RoleBasedGuard } from 'remarketing-angular-library';

import { AgreementsGuard, GUARDS } from 'smartauction-frontend-micro-library';

import { messagesReactGuard } from './guards/messages-react-version.guard';

export const messagesRoutes: Routes = [
  // ---- React routes (remote-profile) ----
  // First match wins. messages-page-enableReact off -> messagesReactGuard's canMatch returns false,
  // this entry does not match, and the Angular MessageOverviewComponent below serves the same path —
  // rollback needs no deploy. Mirrors the dashboard pattern in src/dashboard/dashboard.routes.ts.
  // AuthGuard is added here (absent on the Angular fallback) because the React host reads the token.
  {
    path: 'messages',
    loadComponent: () =>
      import('./react-host/react-messages-overview-host.component').then(
        c => c.ReactMessagesOverviewHostComponent,
      ),
    canMatch: [messagesReactGuard],
    canActivate: [LaunchDarklyUserGuard, AgreementsGuard, AuthGuard, RoleBasedGuard],
    data: {
      flag: 'dashboardEnabled',
      guards: [GUARDS.TermsOfUseGuard, GUARDS.PrivacyPolicyGuard],
      roles: ['View_Only']
    }
  },
  {
    // Resolved by :messageUuid — the migration drops Angular's fragile :messageIndex position
    // contract. No RoleBasedGuard: DEC-2 preserves Angular's list-only View_Only asymmetry.
    path: 'messages/:messageUuid',
    loadComponent: () =>
      import('./react-host/react-messages-detail-host.component').then(
        c => c.ReactMessagesDetailHostComponent,
      ),
    canMatch: [messagesReactGuard],
    canActivate: [LaunchDarklyUserGuard, AgreementsGuard, AuthGuard],
    data: {
      flag: 'dashboardEnabled',
      guards: [GUARDS.TermsOfUseGuard, GUARDS.PrivacyPolicyGuard]
    }
  },
  // ---- Flag-off Angular fallbacks (unchanged from the original config) ----
  {
    path: 'messages',
    loadComponent: () => import('./components/message-overview/message-overview.component').then(c => c.MessageOverviewComponent),
    canActivate: [
      LaunchDarklyUserGuard,
      AgreementsGuard,
      RoleBasedGuard
    ],
    data: {
      flag: 'dashboardEnabled',
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ],
      roles: ['View_Only']
    }
  },
  {
    path: 'messages/:messageIndex',
    loadComponent: () => import('./components/message-detail/message-detail.component').then(c => c.MessageDetailComponent),
    canActivate: [
      LaunchDarklyUserGuard,
      AgreementsGuard
    ],
    data: {
      flag: 'dashboardEnabled',
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ]
    }
  }
];

